import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import deceasedSuppressionPageData from '../data/servicePages/deceasedSuppression';

const DeceasedSuppressionPage = () => <ServicePageLayout data={deceasedSuppressionPageData} />;

export default DeceasedSuppressionPage;
